import { useEffect, useReducer } from 'react'

enum Actions {
  LOAD,
  SET_ROW_STATE,
}

export interface IRowState {
  expanded?: boolean
  defaultExpanded?: boolean
}
interface IState {
  state: { [uid: string]: IRowState }
  defaultState: boolean
}
export interface ITableState extends IState {
  setRowState: (uid: string, state: IRowState) => void
}

function reducer(state: IState, action: any) {
  switch (action.type) {
    case Actions.LOAD:
      return {
        ...state,
        state: action.state,
        defaultState: false,
      }
    case Actions.SET_ROW_STATE:
      const _state = {
        ...state,
        state: {
          ...state.state,
          [action.uid]: {
            ...state.state[action.uid],
            ...action.state,
          },
        },
      }
      if (state.defaultState && action.state.defaultExpanded) {
        /* eslint-disable @typescript-eslint/ban-ts-comment */
        // @ts-ignore
        _state.state[action.uid].expanded = action.state.defaultExpanded
      }
      return _state
    default:
      return state
  }
}

export default function useTableState(name?: string, focus?: string[]): ITableState {
  const key = `gts-${window.location.pathname}-${name}`
  const [data, dispatch] = useReducer(reducer, {
    state: {},
    defaultState: true,
  })

  useEffect(() => {
    if (!name) return
    try {
      const state = localStorage.getItem(key)
      if (!state) return
      dispatch({ type: Actions.LOAD, state: JSON.parse(state) })
    } catch {}
  }, [name, key])
  useEffect(() => {
    if (!focus) return
    for (const uid of focus)
      dispatch({ type: Actions.SET_ROW_STATE, uid, state: { expanded: true } })
  }, [focus])
  useEffect(() => {
    if (!name) return
    localStorage.setItem(key, JSON.stringify(data.state))
  }, [data.state, name, key])

  return {
    ...data,
    setRowState: (uid, state) => dispatch({ type: Actions.SET_ROW_STATE, uid, state }),
  }
}
